/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { HumanityDailyVcIssuanceInfo } from './HumanityDailyVcIssuanceInfo';

export type HumanityHomeVcTotalIssuedCountInfo = {
    TRXHTP: HumanityHomeVcTotalIssuedCountInfo.TRXHTP;
    CHTTP: HumanityHomeVcTotalIssuedCountInfo.CHTTP;
    DATALIST: Array<HumanityDailyVcIssuanceInfo>;
};

export namespace HumanityHomeVcTotalIssuedCountInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }

    export enum CHTTP {
        BLOCK_COUNT = 'BLOCK_COUNT',
        BLOCK_CREATED_TIME = 'BLOCK_CREATED_TIME',
        TRX_COUNT = 'TRX_COUNT',
        TRX_FEE_AVG = 'TRX_FEE_AVG',
        ACCOUNT_COUNT_NEW = 'ACCOUNT_COUNT_NEW',
        UNIQUE_ACTIVE_WALLET = 'UNIQUE_ACTIVE_WALLET',
        VC_TOTAL_ISSUED_COUNT = 'VC_TOTAL_ISSUED_COUNT',
        VC_VERIFIED_PALM_USERS = 'VC_VERIFIED_PALM_USERS',
        VC_TOP_ISSUERS = 'VC_TOP_ISSUERS',
        NETFLOW = 'NETFLOW',
    }


}

